(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg-cp-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rg-cp-motion')) {
    customElements.define('rg-cp-motion', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('[data-rg-cp-video]');
        this.button = this.querySelector('[data-rg-cp-motion-control]');
        if (!this.video || !this.button || this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.userPlayed = false;
        this.failed = false;
        this.video.autoplay = false;
        this.video.muted = true;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (!this.userPaused) this.userPlayed = true;
          this.updatePlayback();
        }, { signal });
        this.video.addEventListener('play', () => this.updateButton(), { signal });
        this.video.addEventListener('pause', () => this.updateButton(), { signal });
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.video.pause();
          this.button.hidden = true;
        }, { signal });
        document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        this.motion.addEventListener('change', () => {
          this.userPlayed = false;
          this.updatePlayback();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries.some(entry => entry.isIntersecting);
            this.updatePlayback();
          }, { threshold: 0.05 });
          this.observer.observe(this);
        } else {
          const checkVisibility = () => {
            const rect = this.getBoundingClientRect();
            this.visible = rect.bottom > 0 && rect.top < window.innerHeight;
            this.updatePlayback();
          };
          window.addEventListener('scroll', checkVisibility, { passive: true, signal });
          window.addEventListener('resize', checkVisibility, { signal });
          checkVisibility();
        }
        this.updateButton();
      }
      shouldPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.failed && !this.userPaused && (!this.motion.matches || this.userPlayed);
      }
      updateButton() {
        this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.dataset.paused = String(this.video.paused);
      }
      updatePlayback() {
        if (!this.shouldPlay()) {
          this.video.pause();
          this.updateButton();
          return;
        }
        if (!this.video.src) {
          this.video.src = this.video.dataset.src;
          this.video.load();
        }
        const playing = this.video.play();
        if (playing) playing.then(() => {
          if (!this.shouldPlay()) this.video.pause();
          this.updateButton();
        }).catch(() => this.updateButton());
      }
      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
